import { useEffect, useState } from "react";
import { cachedRequest } from "./api";

// The server CVI for the signed-in user and a cycle. This is the canonical value for the
// active cycle (the same calculation the finalization service stores). For locked cycles the
// endpoint returns the finalized snapshot.
export default function useLiveCvi(userId, periodId) {
    const [state, setState] = useState({ data: null, loaded: false });
    useEffect(() => {
        let cancelled = false;
        if (!userId || !periodId) { setState({ data: null, loaded: true }); return undefined; }
        setState(prev => ({ data: prev.data, loaded: false }));
        const path = `/api/cvi/periods/${encodeURIComponent(periodId)}/me`;
        cachedRequest(path, { key: `${path}|${userId}` })
            .then(data => { if (!cancelled) setState({ data, loaded: true }); })
            .catch(() => { if (!cancelled) setState({ data: null, loaded: true }); });
        return () => { cancelled = true; };
    }, [userId, periodId]);
    return state;
}
